import React from 'react';
import { LinkProps as ReactLinkProps } from 'react-router-dom';
import { StyledLink } from './styles';
import { TextBaseProps } from './Text';

export type LinkProps = TextBaseProps & ReactLinkProps & React.RefAttributes<HTMLAnchorElement>;

export const Link: React.FC<LinkProps> = StyledLink;
